export interface LegacyAgency {
  id: number;
  name: string;
  siret: string;
}

export default interface Agency {
  id: string;
  name: string;
  legacyId?: number;
}

export enum DB_AGENCIES {
  MEYLAN = '83695b02-a38b-428e-950d-16e99c4cf227',
  PACA = 'cf02130b-3d1c-458d-b47f-498a645d6629',
  ASSODIA = 'd1d1cf85-dd58-4847-9c74-6ba1999b6eb8',
}
